import Vue from 'vue'
import {ptracAutocomplete, ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {byId, resetState, savePayload, updateResult, crudifyMutations} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import {notifyError, sortBy} from '@/utilities/utils'

const initialState = {
  autocompleteResults: [],
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.savePayload = savePayload
getters.byId = byId

const mutations = make.mutations(state)
crudifyMutations(mutations)
mutations.reset = resetState
mutations.updateResult = updateResult
mutations.addResult = (state, entity) => {
  state.results.push(entity)
  state.results = sortBy(state.results, 'label')
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({ state }) {
      const response = await ptracGetEntities('form-fields/search/findAllByOrderByLabelAsc')
      if (OK !== response.status) {
        notifyError(this, 'Failed to load Form Fields')
        return response
      }

      state.results = response.data
      return response
    },
    async fetchAutoCompleteResults({state}, query) {
      const response = await ptracAutocomplete('form-fields/autocomplete?label=' + query)
      if (OK === response.status) {
        state.autocompleteResults = response.data
      }
      return response
    }
  }
}
